import BaseChart from './BaseChart';

/**
 * Sunburst chart implementation using VChart
 */
class SunburstChart extends BaseChart {
  /**
   * Get chart specification for sunburst chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    return {
      type: 'sunburst',
      data,
      nameField: this.options.nameField || 'name',
      valueField: this.options.valueField || 'value',
      childrenField: this.options.childrenField || 'children',
      colorField: this.options.colorField || 'depth',
      
      // Sunburst specific styling
      sunburst: {
        style: {
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.sunburstStyle
        },
        state: {
          hover: {
            stroke: '#fff',
            lineWidth: 2,
            offset: 5
          },
          ...this.options.sunburstState
        }
      },
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
}

export default SunburstChart; 